import { CssBaseline, ThemeProvider } from '@mui/material'
import React, { useState } from 'react'
import { BrowserRouter } from 'react-router-dom'
import './App.css'
import { darkTheme, lightTheme } from './Theme'
import { axiosClient } from './api'
import { STORAGE_KEYS } from './constants'
import { AppRoutes } from './routes'

//TEST UPDATE
const App: React.FC = () => {
  const [isLoaderActive, setIsLoaderActive] = useState(false)
  const [isDarkMode, setIsDarkMode] = useState(() => {
    return localStorage.getItem('theme') === 'dark'
  })

  const toggleTheme = () => {
    setIsDarkMode((prevMode) => {
      const newMode = !prevMode
      localStorage.setItem('theme', newMode ? 'dark' : 'light')
      return newMode
    })
  }

  const showLoader = () => {
    setIsLoaderActive(true)
  }

  const hideLoader = () => {
    setIsLoaderActive(false)
  }

  axiosClient.interceptors.request.use(
    (config) => {
      showLoader()
      const token = localStorage.getItem(STORAGE_KEYS.TOKEN)
      config.headers.Authorization = `Bearer ${token}`
      return config
    },
    (error) => {
      hideLoader()
      return Promise.reject(error)
    }
  )

  axiosClient.interceptors.response.use(
    (response) => {
      hideLoader()
      return response
    },
    (error) => {
      hideLoader()
      // to a toast here
      return Promise.reject(error)
    }
  )

  return (
    <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
      <CssBaseline />
      <BrowserRouter>
        <AppRoutes isLoaderActive={isLoaderActive} toggleTheme={toggleTheme} />
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
